module.exports = __webpack_public_path__ + "static/media/logo_electricity_monitoring.047df3d7.svg";